
import { supabase } from '@/integrations/supabase/client';

export type FileType = 'image/jpeg' | 'image/png' | 'image/gif' | 'image/heic' | 'video/mp4';

export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/heic'];
export const PREMIUM_TYPES = [...ALLOWED_IMAGE_TYPES, 'image/gif', 'video/mp4'];

export const PermissionsService = {
  async canUploadFileType(userId: string, fileType: string): Promise<boolean> {
    if (!userId) return false;

    // Check user roles using the new secure role system
    const { data: roles } = await supabase
      .from('user_roles')
      .select('role')
      .eq('user_id', userId)
      .in('role', ['admin', 'premium'])
      .or('expires_at.is.null,expires_at.gt.now()');

    // Basic image types allowed for all users
    if (ALLOWED_IMAGE_TYPES.includes(fileType)) {
      return true;
    }

    // Premium types only for admin/premium users
    const hasPermission = roles && roles.length > 0;
    return hasPermission && PREMIUM_TYPES.includes(fileType);
  },

  getAcceptedTypes(isPremium: boolean): string {
    return isPremium 
      ? PREMIUM_TYPES.join(',')
      : ALLOWED_IMAGE_TYPES.join(',');
  }
};
